var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4MensShower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 19.94V72h-4V19.94c0-9.1-6.09-12.75-11.31-13.12-4-.27-8.2 1.3-10.46 4.7A8 8 0 0140.41 19h-16a8 8 0 016.44-7.85C33.53 5.2 40 2.44 46 2.86c7.45.52 15 6 15 17.08zM38 33H26a5 5 0 00-5 5v12a2 2 0 004 0V38a1 1 0 011-1h1v33a2 2 0 004 0V53.94h2V70a2 2 0 004 0V37h1a1 1 0 011 1v12a2 2 0 004 0V38a5 5 0 00-5-5zm-3.42-2.94a4 4 0 10-5.16-6.113 4 4 0 005.16 6.113z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_Mens_shower.e628a39d.svg";
export { SvgE4MensShower as ReactComponent };